var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.603,
    height: 23.618,
    viewBox: "0 0 24.603 23.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f2fd3;stroke:#6f2fd3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.17 -581.191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.273,39.118H18.11a.609.609,0,0,1-.431-1.04l3.092-3.092a10.81,10.81,0,1,1,8.5,4.132",
    transform: "translate(-1.309 564.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M174.483,83.427a1.361,1.361,0,1,0-2.722-.032l-.009.779a1.361,1.361,0,1,0,2.722.032Z",
    transform: "translate(-145.15 504.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M174.486,150.859a1.361,1.361,0,0,0-2.722,0l.008,5.7a1.361,1.361,0,0,0,2.722,0Z",
    transform: "translate(-145.161 441.571)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActiveIcon);
export default __webpack_public_path__ + "static/media/helpActiveIcon.241358d2fa70b5082598ba28fd71c1f1.svg";
export { ForwardRef as ReactComponent };